module.exports = __webpack_public_path__ + "media/images/lapiz-d57a16e1.png";